import {formatTwoDigits} from '../format/formatTwoDigits';

export function secondsToMinutesAndSeconds(sec: number) {
  const minutes = Math.floor(sec / 60);
  const seconds = sec - minutes * 60;

  return `${formatTwoDigits(minutes)}:${formatTwoDigits(seconds)}`;
}
